import fileData from "@/data/file";
import inputData from "@/data/input";
import selectionsData from "@/data/selections";

const { tracks: tracksSelectionKey, videoTypes: videoTypesSelectionKey } = selectionsData.keys;

const { video: videoFileName, videoThumbnail: videoThumbnailFileName } = fileData.names;

const { autoComplete: autoCompleteInputType, file: fileInputType, text: textInputType } = inputData.types;

const { isrc: isrcInputName, track: trackInputName, type: typeInputName } = inputData.names;

const {
    isrc: isrcInputLabel,
    thumbnail: thumbnailFileInputLabel,
    track: trackInputLabel,
    type: typeInputLabel,
    video: videoFileInputLabel,
} = inputData.labels;

const releaseVideoFormData = [
    {
        col: {
            md: 4,
            xs: 12,
        },
        label: trackInputLabel,
        name: trackInputName,
        selectionKey: tracksSelectionKey,
        type: autoCompleteInputType,
    },
    {
        col: {
            md: 4,
            xs: 12,
        },
        label: typeInputLabel,
        name: typeInputName,
        selectionKey: videoTypesSelectionKey,
        type: autoCompleteInputType,
    },
    {
        col: {
            md: 4,
            xs: 12,
        },
        label: isrcInputLabel,
        name: isrcInputName,
        type: textInputType,
    },
    {
        col: {
            md: "auto",
            xs: 12,
        },
        label: videoFileInputLabel,
        name: videoFileName,
        type: fileInputType,
    },
    {
        col: {
            md: "auto",
            xs: 12,
        },
        isOptional: true,
        label: thumbnailFileInputLabel,
        name: videoThumbnailFileName,
        type: fileInputType,
    },
];

export default releaseVideoFormData;
